import { BusinessEventDetailsValueType } from '../../models/BusinessEvent'

export const getBusinessEventDetailsDisplayValue = (value: BusinessEventDetailsValueType): string | number => {
  if (value === null) {
    return '-'
  }

  if (Array.isArray(value)) {
    return value
      .filter((item) => item !== null)
      .map(getBusinessEventDetailsDisplayValue)
      .join(', ')
  }

  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No'
  }

  if (typeof value === 'number') {
    return value.toLocaleString('en-US')
  }

  return value
}
